<template>
  <div class="hit-row">

      <div class="hit-col-md-12">

        <ul class="hit-nav hit-nav-tabs">
          <li class="hit-html-li" v-bind:class="{'hit-active': (active == index)}" v-for="(part, index) in parts" >
            <a href="#" class="hit-html-a" v-on:click.prevent="set_active(index)" >
              {{ $tc("message."+part[0]) }} {{ part[1] }}
            </a>
          </li>
      </ul>

      <transition name="slideDown">
      <div class="hit-panel hit-panel-default" v-if="active" :key="active">
        <div class="hit-panel-body">

          <div class="hit-form-group">
            <label class="hit-html-label" for="col">{{ $tc("message."+parts[active][0]) }} {{ parts[active][1] }}</label>
              <hit_color  :id="'col'" :color="parts[active][2]" :callback="function(col){ set_col(col); }" />
          </div>

            <div class="hit-text-right">
              <a href="#" class="hit-btn hit-btn-default hit-btn-xs" v-on:click.prevent="function(){ set_col(''); active=false;}"><hit_icon :id="'bin'" /></a>
            </div>
        </div>
        <div class="hit-panel-body" v-if="active == 'background_color'">
          <background_image v-if="" :vals="vals" :callback="function(img){ callback('background_image', img); }"/>
        </div>
      </div>

    </transition>

    </div>

  </div>
</template>

<script>

import background_image from '@core/components/content/landingpage/background_image'

export default{

  components: { background_image },

  props: {
    callback: Function,
    vals: Object
  },
  data () {
    return {

      parts: {

        background_color: ['background_color', '', this.vals.background_color],
        accent_color: ['accent_color', '', this.vals.accent_color],
        accent_color2: ['accent_color', '2', this.vals.accent_color2],
        text: ['text_color', '', this.vals.text]
      },

      active: false
    }
  },

  methods: {

    set_col (col) {
      this.parts[this.active][2] = col

      this.callback(this.active, col)
    },
    set_active (active) {
      if (this.active == active) {
        this.active = false
        return false
      }

      this.active = active
    }
  }
}
</script>
